'use client'

import { useRouter } from '@/i18n/navigation'
import { useEffect } from 'react'
import { PROVIDER_ROUTES, ROUTES } from '../constants/routes'
import { useAuth } from '../store/auth'
import { AccountType } from '../types/enums/account-type.enum'

type Props = {
  children: React.ReactNode
}

export const CustomerGuard: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, accountType, status } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (status === 'pending') return
    if (isAuthenticated && accountType === AccountType.CUSTOMER) {
      return
    }
    if (isAuthenticated && accountType === AccountType.PROVIDER) {
      return router.replace(PROVIDER_ROUTES.trips)
    }
    if (!isAuthenticated) {
      return router.replace(ROUTES.home)
    }
  }, [isAuthenticated, accountType, router, status])

  return children
}
